import React, { useEffect } from "react";

import etg from "../../../assets/img/brands/etg.png";
import kynoch from "../../../assets/img/brands/kynoch.png";
import falcon from "../../../assets/img/brands/falcon.png";
import oemff from "../../../assets/img/brands/oemff.png";
import "./Brands.css";
import { Link } from "react-router-dom";
import { useListAllBrandQuery } from "../../products/productSlice";
import axios from "axios";
import { AiFillCar } from "react-icons/ai";
import { RiArrowGoForwardLine } from "react-icons/ri";
import { FaMoneyBill } from "react-icons/fa";
import { BsShieldLockFill } from "react-icons/bs";

const imgs = [etg, kynoch, falcon, oemff];

function Brands() {
  // const { data, isLoading, error } = useListAllBrandQuery()

  return (
    <>
      <div className="brandSec bgGray">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="mainRap">
                <div className="icon">
                  <AiFillCar />
                </div>
                <div className="text">
                  <h6>Speedy delivery</h6>
                  <p>Orders from all item</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="mainRap">
                <div className="icon">
                  <RiArrowGoForwardLine />
                </div>
                <div className="text">
                  <h6>Easy returns</h6>
                  <p>On all unused items</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="mainRap">
                <div className="icon">
                  <FaMoneyBill />
                </div>
                <div className="text">
                  <h6>Online support</h6>
                  <p>Alway online 24/7</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="mainRap">
                <div className="icon">
                  <BsShieldLockFill />
                </div>
                <div className="text">
                  <h6>Secure payment</h6>
                  <p>100% Secure payment</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Brands;
